module.exports = function () {
	var pageHead = $('.pageTitle_wrap');
	if(pageHead.length) {
		insertBgImage(pageHead);
	}
}

function insertBgImage(target) {
	var bgValue;
	if(target.data('bg') == false) {
		bgValue = 'none';
	} else {
		bgValue = 'url(' + target.data('bg') + ')';
	}
	target.css('background-image', bgValue);
}


//////////////////
// WEBPACK FOOTER
// ./src/resources/js/modules/insert_bgimage.js
// module id = 5
// module chunks = 0